// src/components/common/PageHeader/PageHeader.jsx
import React from "react";
import "./PageHeader.css";

export default function PageHeader({
  title,
  buttonLabel,
  onButtonClick,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  tertiaryButtonLabel,
  onTertiaryButtonClick,
}) {
  return (
    <div className="page-header">
      <h1 className="page-header-title">{title}</h1>

      {(tertiaryButtonLabel || secondaryButtonLabel || buttonLabel) && (
        <div className="page-header-actions">
          {tertiaryButtonLabel && (
            <button
              className="page-header-button page-header-button-secondary"
              onClick={onTertiaryButtonClick}
            >
              {tertiaryButtonLabel}
            </button>
          )}

          {secondaryButtonLabel && (
            <button
              className="page-header-button page-header-button-secondary"
              onClick={onSecondaryButtonClick}
            >
              {secondaryButtonLabel}
            </button>
          )}

          {buttonLabel && (
            <button className="page-header-button" onClick={onButtonClick}>
              {/* <span className="material-symbols-outlined page-header-button-icon">
                add
              </span> */}
              {buttonLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
